export default __webpack_public_path__ + "maps-examples-camera-animation-1200-b89792096eee610c00a1df6c1da941df.webp";